export const CONFIRMATION_DIALOG_ID = 'CONFIRMATION_DIALOG'
